import { IS_APP, IS_TESTING } from "@/__main__/constants.mjs";
import eventBus from "@/app/app-event-bus.mjs";
import { EVENT_TRACK_AD_VIDEO_VIEW } from "@/feature-ads/constants/events.mjs";
import { getPageTargetingMap } from "@/feature-ads/display-server-google.mjs";
import adsRefs from "@/feature-ads/refs.mjs";
import { devLog } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";

const SCRIPT_URL = "https://static.vidazoo.com/basev/vwpt.js";
const WIDGET_ID = "6539773c4f44e1e595adc181";
let isInitializePlacement = false;
let vidazooWidgetRef = null;
export const VIDEO_VIDAZOO = {
  aspectRatio: "16 / 9",
  init: () => {},
  initializePlacement(/*element: HTMLElement*/) {
    const placement = globals.document.createElement("div");
    placement.style.position = "relative";
    placement.id = "vidazoo-widget";
    if (IS_TESTING || isInitializePlacement) return placement;
    isInitializePlacement = true;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (window as any).onWidgetCreated = function (widget) {
      vidazooWidgetRef = new WeakRef(widget);
      widget.on("adImpression", async (data) => {
        let ram = 0;
        if (IS_APP) {
          const heapStats = await globals.__BLITZ__.process.getHeapStatistics();
          ram = heapStats.usedHeapSize * 1024;
          // @ts-ignore
        } else if (globals.performance.memory) {
          // @ts-ignore
          ram = globals.performance.memory.usedJSHeapSize;
        }
        eventBus.emit(EVENT_TRACK_AD_VIDEO_VIEW, {
          provider: "vidazoo",
          ram,
        });
        devLog("[Vidazoo] AdImpression", data);
      });
    };
    const scriptEl = globals.document.createElement("script");
    scriptEl.src = SCRIPT_URL;
    scriptEl.setAttribute("data-widget-id", WIDGET_ID);
    scriptEl.setAttribute("data-widget-created", "onWidgetCreated");

    adsRefs
      .googleCmd(() => {})
      .then(() => {
        const pageTargeting = getPageTargetingMap();
        if (pageTargeting) {
          scriptEl.setAttribute("data-param1", pageTargeting.game);
          scriptEl.setAttribute("data-param2", pageTargeting.route);
          scriptEl.setAttribute("data-ext-bi-custom1", IS_APP ? "1" : "0");
        }
      });
    placement.appendChild(scriptEl);
    return placement;
  },
  onPlacementAppend(_parent: HTMLElement, _placement: HTMLElement) {},
  onDestroy(_activeRef) {
    const vidazooWidget = vidazooWidgetRef?.deref();
    if (vidazooWidget) {
      vidazooWidget.destroy();
    } else {
      vidazooWidgetRef = null;
    }
  }, // noop
  vendorCloseButton: true,
  vendorIntersectionFloat: !IS_TESTING,
  vendorNavFloat: false,
  onNavFloat: () => {},
};
